/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Title"
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let cardTitleValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'title',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="Title.Horizontal"
  data-view-path={viewPath}
 style={{'--pr-1-5P3Cr': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="card.title"
 text={cardTitleValueData}
 color={dtColorsNeutral900}
 size="small"
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 overflowX="hidden"
 display="block"
/>
</div>
{children}
</React.Fragment>)
}